import { useCallback, useEffect, useState } from "react";
import { api, errText } from "../../lib/api";
import { SettingsPanel } from "./SettingsPanel";

export default function SettingsPage() {
  const [settings, setSettings] = useState(null);
  const [error, setError] = useState("");
  const load = useCallback(() => api.get("/admin/settings").then((r) => setSettings(r.data)).catch((e) => setError(errText(e))), []);
  useEffect(() => { load(); }, [load]);

  if (error) return <p className="text-danger text-sm" data-testid="settings-error">{error}</p>;
  if (!settings) return <p className="text-sm text-muted" data-testid="settings-loading">Loading settings…</p>;
  return <SettingsPanel settings={settings} onSaved={load} />;
}
